import packShared from 'shared/pack-shared';

import shared, { fetchJSON, ajaxPost, notify, config } from 'shared/shared';

import i18n from 'shared/i18n/i18n';

import { US } from 'shared/constants';
import DOMPurify from 'shared/dompurify';

import schoolSelector from 'shared/widget/school-selector';


let localizedString = i18n.string;

const subjectPath = shared.getSubjectAreaPath();

const subjectId = shared.getSubjectAreaId();

const onGenericError = () => {
    notify(localizedString('packs.custom.generic.error.message'), 'danger');
};

let saved = false;

let isTeacher = shared.config.isTeacher();

let individualId = shared.config.individualId;

let individualSessionParamNameForModal = individualId + '-' + config.subjectAreaId + '-account-preferences-modal-seen';

let timeBetweenModalDisplays = 60 * 60 * 24 * 14 * 1000;

let gradeUrl = `/${subjectPath}/getGradesForTerritory`;

let topicUrl = `/${subjectPath}/getTopicsForTerritory`;

let _grades = ko.observableArray([]);

let _topics = ko.observableArray([]);

let _selectedGrades = ko.observableArray([]);

let _selectedTopics = ko.observableArray([]);

let _interests = ko.observable('');



fetchJSON(gradeUrl, _grades);

fetchJSON(topicUrl, _topics);

let _steps = ['step-school-info', 'step-grades', 'step-topics', 'step-interests', 'step-last'];

let _currentStep = ko.observable('');

const getInitialStep = () => {
    if (!schoolSelector.school()) {
        return _steps[0];
    }

    if (!_selectedGrades().length) {
        return _steps[1];
    }

    if (!_selectedTopics().length) {
        return _steps[2];
    }

    return '';
};

const canGoNext = (currentStep) => {

    let _canGoNext = true;

    switch (currentStep) {
        case 'step-school-info':
            schoolSelector.validate();
            _canGoNext = (schoolSelector.school() || schoolSelector.schoolName())  && schoolSelector.country() && (schoolSelector.country().countryId !== US.countryId || schoolSelector.country().countryId === US.countryId && schoolSelector.state());
            break;
        case 'step-grades':
            _canGoNext = !!_selectedGrades().length;
            break;
        case 'step-topics':
            _canGoNext = !!_selectedTopics().length;
            break;
    }

    return _canGoNext;
};

let _showErrorMessages = {};


const _next = () => {

    if (!canGoNext(_currentStep())) {
        _showErrorMessages[_currentStep()](true);

        return;
    }

    _showErrorMessages[_currentStep()](false);

    let currentIndex = _steps.indexOf(_currentStep());

    if (_steps.length > currentIndex) {
        _currentStep(_steps[currentIndex + 1]);
    }
};

const _prev = () => {

    let currentIndex = _steps.indexOf(_currentStep());

    if (currentIndex > 0) {
        _currentStep(_steps[currentIndex - 1]);
    }
};

const onLastPage = () => {


    setTimeout(() => {

        const thankYouIcon = $('.step-last .thank-you-icon');
        thankYouIcon.animateCss('zoomIn');
        thankYouIcon.show();

        setTimeout(() => {
            const thankYouText = $('.step-last .thank-you-text');
            thankYouText.animateCss('slideInUp');
            thankYouText.show();
        }, 800);

    }, 400);

    savePreferences();
    saved = true;

    setTimeout(function() {
        $('#account-preferences-modal').modal('hide');
    }, 8000);
};

_currentStep.subscribe(function (val) {

    switch (val) {
        case 'step-last':
            onLastPage();
            break;
        default:
            break;
    }
});

let _cssClasses = {};

_steps.slice(0, _steps.length - 1).forEach(function(val, index) {

    _showErrorMessages[val] = ko.observable(false);

    _cssClasses[val] = ko.computed(function() {

        let currentIndex = _steps.indexOf(_currentStep());

        if(currentIndex > index) {
            return 'progress-done';
        } else if (currentIndex == index) {
            return 'progress-done progress-current';
        } else {
            return 'progress-todo';
        }
    });
});


schoolSelector.init('.school-typeahead', i18n.string('school.selector.modal.title'), _next);


let model = {
    grades: _grades,
    selectedGrades: _selectedGrades,
    topics: _topics,
    selectedTopics: _selectedTopics,
    interests: _interests,
    steps: ko.observableArray(_steps),
    currentStep: _currentStep,
    cssClasses: _cssClasses,
    next: _next,
    prev: _prev,
    showErrorMessages: _showErrorMessages,

    schoolSelector: schoolSelector
};


const savePreferences = (saveAnyway) => {

    saveAnyway = !!saveAnyway;  // http://jira.britannica.net/browse/PAC-712

    let tks = Object.assign({}, schoolSelector.getData());

    tks.gradeIds = _selectedGrades();

    tks.topicIds = _selectedTopics();

    tks.additionalTopics = _interests();

    if (schoolSelector.validate() || saveAnyway) {

        if(saveAnyway) {  // http://jira.britannica.net/browse/PAC-958

            if (!tks.stateName) {
                tks.schoolName = '';
                tks.districtName = '';
            }
        }

        const onResponse = (response) => {
            if (response) {
                let serverErrors = Object.keys(response).filter((item) => {
                    return !response[item];
                });

                if (serverErrors.length) {
                    onGenericError();
                }
            }
        };

        ajaxPost(`/${subjectPath}/saveAccountDetails`, tks).done(onResponse).fail(onGenericError);
    }

};


const parseAccountDetails = (data) => {

    schoolSelector.setData(data);

    let subjectPreferences = data.subjectPreferences[subjectId] || {};

    if(subjectPreferences.singleGradeInfos) {
        let selectedGrades = subjectPreferences.singleGradeInfos.map((g) => {
            return g.gradeId;
        });
        _selectedGrades(selectedGrades);
    }

    if(subjectPreferences.topicInfos) {
        let selectedTopics = subjectPreferences.topicInfos.map((g) => {
            return g.topicId;
        });
        _selectedTopics(selectedTopics);
    }

    if(subjectPreferences.additionalTopics) {
        _interests(subjectPreferences.additionalTopics);
    }

};


const fetchPreferences = (callback) => {
    fetchJSON(`/${subjectPath}/fetchAccountDetails`, (response) => {
        parseAccountDetails(response);
        callback && callback();
    });

};


const buildModal = () => {

    let now = Date.now();

    _currentStep(getInitialStep());

    if(_currentStep() == _steps[0]) {
        schoolSelector.showSchoolSelector(true);
    }

    let element = document.getElementById('account-preferences-modal');

    if(!element && _currentStep()) {

        element = document.createElement('div');

        element.innerHTML = DOMPurify.sanitize('<div data-bind="template: { name: \'account-preferences-modal-template\'}"></div>');

        document.querySelector('body').appendChild(element);

        ko.cleanNode(element);

        ko.applyBindings(model, element);

        let $modal = $('#account-preferences-modal');

        $modal.modal({ show: true, backdrop: 'static'});

        $modal.on('hidden.bs.modal', () => {
            if(!saved) {
                savePreferences(true);
            }
        });

        packShared.setSessionVar(individualSessionParamNameForModal, now, true);
    }
};


export default {
    show: function () {

        let lastSeenModal = packShared.getSessionVar(individualSessionParamNameForModal, true);

        let now = Date.now();

        let showModal = isTeacher && (now - timeBetweenModalDisplays) > lastSeenModal;

        if(showModal) {
            fetchPreferences(buildModal);
        }
    }
}



// WEBPACK FOOTER //
// ./javascript/app/page/common/includes/account-preferences.js